module.exports = __webpack_public_path__ + "static/media/Abdullah Furaiji.b64b6d1b.jpg";